import React from 'react';
import './Contact.css';

const Contact = () => {
  return (
    <section className="contact-section" id="contact">
      <h2>İletişime Geçin</h2>
      <p>
  Mersin'deki ofisimize ulaşarak Canon fotokopi tamiri, yazıcı servisi, toner dolumu ve kiralama hizmetlerinden yararlanabilirsiniz.
</p>

      <p>Bize aşağıdaki yöntemlerle kolayca ulaşabilirsiniz:</p>

      <div className="contact-buttons">
        <a
          href="https://wa.me/905324840907"
          className="contact-button whatsapp"
          target="_blank"
          rel="noopener noreferrer"
        >
          WhatsApp'tan Yaz
        </a>

        <a
          href="mailto:ferhankucuk@hotmail.com"
          className="contact-button email"
        >
          E-posta Gönder:ferhankucuk@hotmail.com
        </a>

        <a
          href="tel:+905324840907"
          className="contact-button email"
        >
           Telefonu Ara:+90 532 484 09 07
        </a>

        <a
          href="https://www.google.com/maps/@36.7951288,34.6235014,21z?entry=ttu&g_ep=EgoyMDI1MDcyMS4wIKXMDSoASAFQAw%3D%3D"
          className="contact-button email"
        >
          
        Adresimiz:     Kiremithane Mahallesi , 4406 Sokak , Müzeyyen Boro İşhanı, 5/34 ,
         Akdeniz, Mersin,
         Turkey


        </a>
      </div>
    </section>
  );
};

export default Contact;
